import SmoothScroll from 'smooth-scroll';

var scroll = new SmoothScroll('a[href*="#"]', {
  speed: 400,
  speedAsDuration: true,
  updateURL: false
});

const modal = document.querySelector('.Point1__modal');
const button = document.querySelectorAll('.modal-toggle');

button.forEach(e => {
  e.addEventListener('click', () => {
    modal.classList.toggle('Point1__modal--open');
  });
});

lazyload()
AOS.init();

document.querySelectorAll('img').forEach((img) => img.addEventListener('load', () => AOS.refresh()));
